export class LogbookPersistenceKey {
  static readonly HIDDEN_COLUMNS = 'logbook/persistence/hidden-columns';
}
